import React from 'react';
import './App.css';
import Chatbot from './pages/Chatbot/Chatbot';
import { AuthenticatedLayout } from './components/layout/Layout/Layout';
import ChatbotLogin from './pages/Login/Login';
import ChatbotAvatar from './pages/Avatar/Avatar';
import HrTopicsAndFaqs from './pages/HRBuddy/HRBuddy';
import ChatMessages from './pages/Chatbot/Chat';
import { Route, Routes } from 'react-router';
import Admin from './pages/Admin/Admin';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div className="App">
      {/* <AuthenticatedLayout> */}
      <Routes>
      <Route element={<ChatbotAvatar/>} path="/:id/login" />
      <Route element={<ChatbotAvatar/>} path="/:id" />
      <Route element={<Chatbot/>} path="/:id/chatbot" />
     <Route element={<Admin/>} path='/admin/*' />
      </Routes>

   
    
      {/* </AuthenticatedLayout> */}
      <ToastContainer />
    </div>
  );
}

export default App;
